import { forwardRef, useImperativeHandle, useRef } from "react";
import styled from "styled-components";
import * as animationData from '../../assets/lotties/transfer_loader.json';
import Lottie from "react-lottie";

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};


const StyledLoaderModal = styled.dialog`
    width: 250px;
    height: 250px;
    display: none;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 25px;
    border-radius: 35px;
    background-color: #1C1C1C;
    border-width: 0px;

    &[open] {
        display: flex;
    }

    &::backdrop {
        background-color: #00000090;
    }

    #title{
        font-size: 22px;
        color: #FFFFFF;
    }

    #subtitle{
        font-size: 18px;
        color: #FFFFFF;
        text-align: center;
    }
`;

const LoaderModal = forwardRef(function LoaderModal({title, subtitle}, ref){

    const modalRef = useRef();

    useImperativeHandle(ref, () => {
            return {
                open: open,
                close: close,
            };
        });
    
        function open() {
            modalRef.current.showModal();
        }
    
        function close() {
            modalRef.current.close();
        }

    return (
        <StyledLoaderModal ref={modalRef}>
            <p id="title">{title}</p>
                <Lottie options={defaultOptions} height={128} width={128} />
            <p id="subtitle">{subtitle}</p>
        </StyledLoaderModal>
    );
});

export default LoaderModal;